module.exports = __webpack_public_path__ + "static/media/cf.27dcdd05.png";